import { useCallback, useEffect, useState } from 'react'

export const useEventState = <T = boolean>(
  defaultValue: T = false as T,
  onChange?: (value: T) => void,
) => {
  const [eventState, setEventState] = useState<T>(defaultValue)

  useEffect(() => {
    onChange?.(eventState)
  }, [eventState])

  return [eventState, setEventState] as const
}

export const useEventSwitchState = (
  defaultValue = false,
  onChange?: (value: boolean) => void,
) => {
  const [eventState, setEventState] = useEventState(defaultValue, onChange)

  const open = useCallback(() => setEventState(true), [])
  const close = useCallback(() => setEventState(false), [])

  return [eventState, open, close] as const
}
